import {
  initialState,
  Actions,
  State,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_ERROR,
  RESET_DELETE_NOTIFICATION,
} from "../../types/notification/delete";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_NOTIFICATION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_NOTIFICATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
